import "./appStoreLink.scss";
import downloadIOS from "./download-on-app-store.png";
import downloadAndroid from "./download-on-google-play.png";
import {
  DownloadFromAppStoreButton,
  DownloadFromGooglePlayButton,
} from "../library";

const aspectRatio = 300 / 80;

type AppStoreLinkProps = {
  type: "ios" | "android";
  width?: number;
};
const AppStoreLink = ({ type, width = 150 }: AppStoreLinkProps) => {
  const appStoreUrl =
    type === "android"
      ? "https://play.google.com/store/apps/details?id=com.unitelife.mynota"
      : "https://apps.apple.com/app/apple-store/id1630818598?pt=127358328&ct=July%20Marketing%20Campaign%202025&mt=8";
  return (
    <div
      className="app-store-link"
      onClick={() => {
        // @ts-ignore
        window.gtag("event", "click_appstore_link", {
          event_category: `Download Button Click - ${type}`,
          event_label: `App Store link click - ${type}`,
          transport_type: "beacon",
        });
        setTimeout(() => {
          window.open(appStoreUrl, "_blank", "noopener,noreferrer");
        }, 200);
      }}
      style={{ width, height: width / aspectRatio }}
    >
      {type === "ios" ? (
        <DownloadFromAppStoreButton />
      ) : (
        <DownloadFromGooglePlayButton />
      )}
      {/*<img src={type === "ios" ? downloadIOS : downloadAndroid} />*/}
    </div>
  );
};

export default AppStoreLink;
